import { render, staticRenderFns } from "./MergerAcquistionTable.vue?vue&type=template&id=61d67c22&"
import script from "./MergerAcquistionTable.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquistionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports